package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiMessageFactory {

  private def TemplateMessage(contents: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("message"),
      style := uiElementModifiers.createStyle
    )(
      contents:_*
    )
  }


  def BasicMessage(message: String)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateMessage(message)(uiElementModifiers)
  }
  def BasicErrorMessage(message: String)(implicit uiElementModifiers: UiElementModifiers) = {
    val messageModifiers = "negative " + uiElementModifiers.elementModifiers
    BasicMessage(message)(messageModifiers, uiElementModifiers.classString, uiElementModifiers.styleAttributes)
  }

}

